require('./cardsCancelPayLaterInformationStep.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @constants
const CLASS_NAME = 'cards-cancel-pay-later-information-step';

class CardsCancelPayLaterInformationStep extends React.Component {

    render() {
        const {
            informativeList,
        } = this.props;

        return (
            <div className={`${CLASS_NAME}`}>
                <div className={`${CLASS_NAME}__title`}>
                    <FormattedText value="cardsCancelPayLater-cardsCancelPayLater_title" />
                </div>
                <div className={`${CLASS_NAME}__subtitle`}>
                    <FormattedText value="cardsCancelPayLater-cardsCancelPayLater_subtitle" />
                </div>
                {informativeList}
            </div>
        );
    }
}

CardsCancelPayLaterInformationStep.propTypes = {
    informativeList: PropTypes.any,
    immCardCancelPayLater: PropTypes.object.isRequired,
};

module.exports = CardsCancelPayLaterInformationStep;